import LineOrange from "../../../common/LineOrange/LineOrange";

export const CertificateBenefits2 = (src) => {
  return (
    <>
      <div
        style={{ minHeight: "", backgroundColor: "" }}
        className="d-flex justify-content-center align-items-center"
      >
        <div className="container">
          <div className="title d-flex flex-column">
            <h3 className="text-right mt-5">
              شرایط پذیرش شرکت‌ها در بورس و فرابورس
            </h3>
            <LineOrange />
          </div>
          <div
            className="d-flex  align-items-start justify-content-center mb-5 mt-5"
            style={{ minHeight: "50vh" }}
          >
            <div className="row align-items-center w-100 ">
              <div className="col-12 col-lg-6">
                <ul className="text-right mt-3" style={{ width: "565px" }}>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    سهامی عام{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    ثبت شده نزد سازمان بورس و اوراق بهادار{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    اظهار نظر مقبول یا مشروط حسابرس در خصوص صورتهای مالی{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    برخورداری از سیستم اطلاعات حسابداری مطلوب و متناسب با فعالیت{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    داشتن صورت های مالی مطابق با استانداردهای حسابداری و دستور
                    العمل های اجرایی سازمان بورس
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    عدم محدودیت قانونی موثر برای نقل و انتقال سهام شرکت
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    نداشتن محکومیت قطعی کیفری یا تخلفاتی موثر اعضای هیئت مدیره و
                    مدیر عامل شرکت{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    سهام با نام و بهای اسمی آن تماما پرداخت شده باشد{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    دارای حسابرس معتمد سازمان{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    نداشتن دعاوی دارای اثر با اهمیت بر صورتهای مالی{" "}
                  </li>
                </ul>
              </div>
              {/* <div className="col-12 col-lg-6">
                <div className="text-center">
                  <img
                    src={"/asset/images/01.png"}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
